<ng-container *ngIf="filters.length > 0">
    <div class="row">
        <div *ngFor="let filter of filters" [ngClass]="getFilterNgClass(filter)">
            <label>{{ filter.label }}</label>
            <div *ngIf="filter.tipo === 'input'">
                <app-input
                    *ngIf="!filter.options || !filter.options.length"
                    [compact]="true"
                    [styleClasses]="'form-control'"
                    [inputId]="'filtro-' + filter.campo"
                    [name]="'filtro-' + filter.campo"
                    [(ngModel)]="filter.value"
                    (ngModelChange)="onInputFilterChange()"
                    [requiredMayusculas]="!!filter.requiredMayusculas"
                    [placeholder]="filter.placeholder || filter.label">
                </app-input>
            </div>
            <div *ngIf="filter.tipo === 'select'">
                <select
                    class="form-control filter-select"
                    [class.filter-select--placeholder]="isFilterSelectEmpty(filter.value)"
                    [(ngModel)]="filter.value"
                    [compareWith]="compareFilterValues"
                    (ngModelChange)="onSelectFilterChange()">
                    <option [ngValue]="''">--</option>
                    <option *ngFor="let option of filter.options ?? []" [ngValue]="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>
            <div *ngIf="filter.tipo === 'input-typeahead'">
                <app-input-typeahead
                    [compact]="true"
                    [styleClasses]="'form-control'"
                    [inputId]="'filtro-' + filter.campo"
                    [(ngModel)]="filter.value"
                    (valueChange)="onInputFilterChange()"
                    [placeholder]="filter.placeholder || filter.label"
                    [searchFn]="getTypeaheadSearchFn(filter)"
                    [resolveFn]="getTypeaheadResolveFn(filter)"
                    [options]="getTypeaheadOptions(filter)"
                    [valueKey]="getTypeaheadValueKey(filter)"
                    [displayKeys]="getTypeaheadDisplayKeys(filter)"
                    [minSearchLength]="getTypeaheadMinLength(filter)">
                </app-input-typeahead>
            </div>
        </div>
    </div>
    <div class="row my-2">
        <div class="col-12 d-flex justify-content-end align-items-center gap-2 flex-wrap">
            <app-button
                *ngIf="mostrarBotonLimpiar"
                label="Limpiar"
                variant="secondary"
                extraClasses="w-auto"
                (clicked)="cleanFilters()">
            </app-button>
            <app-button
                *ngIf="mostrarBotonAplicar"
                label="Aplicar"
                variant="primary"
                extraClasses="w-auto"
                (clicked)="applyFilters()">
            </app-button>
            <app-button
                *ngIf="mostrarBotonEditar || editFilter"
                label="Editar"
                variant="success"
                extraClasses="w-auto"
                (clicked)="onEditar()">
            </app-button>
        </div>
    </div>
</ng-container>
<div class="row mt-3">
    <div class="col-md-12 table-responsive">
        
        <!-- Componente de paginación superior -->
        <app-paginacion-superior
            [paginaActual]="page"
            [totalPaginas]="totalPaginas"
            [totalRegistros]="total"
            [limite]="pageSize"
            [opcionesLimite]="pageSizeOptions"
            [textoRegistros]="textoRegistros"
            [textoMostrar]="textoMostrar"
            [mostrarEnlaceRelacionar]="mostrarEnlaceRelacionar"
            (paginaAnterior)="onPaginaAnterior()"
            (paginaSiguiente)="onPaginaSiguiente()"
            (cambiarLimite)="onCambiarLimite($event)">
        </app-paginacion-superior>
        <div class="table-scroll">
        <table
            class="table table-striped"
            [class.table-has-checkboxes]="showCheckboxes"
            [class.table-layout-fixed]="usaLayoutFijo">
            <colgroup>
                <col *ngIf="showCheckboxes" class="table-checkbox-col-width" />
                <col
                    *ngFor="let column of columns"
                    [style.width]="getColumnWidth(column)" />
            </colgroup>
            <thead class="table-success">
                <tr>
                    <th *ngIf="showCheckboxes" class="table-checkbox-col">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            [checked]="allRowsOnPageSelected"
                            (change)="onToggleAllOnPageChange($any($event.target).checked)"
                            aria-label="Seleccionar todos en esta página" />
                    </th>
                    <th
                        *ngFor="let column of columns"
                        class="table-data-col"
                        [style.width]="getColumnWidth(column)">
                        {{ column.label }}
                        <app-icono-filtro
                            *ngIf="mostrarIconoFiltro(column) && column.activateFilter!==false"
                            [tipo]="tipoIconoFiltro(column)"
                            [opciones]="opcionesIconoFiltro(column)"
                            [placeholder]="placeholderIconoFiltro(column)"
                            [value]="valorInicialFiltro(column)"
                            (filtrar)="
                                onFiltroColumna(column.campo, $event)
                            "></app-icono-filtro>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="!data?.length">
                    <td [attr.colspan]="colspanTabla" class="text-center text-muted py-3">
                        No se encontraron registros que coincidan con la búsqueda.
                    </td>
                </tr>
                <tr *ngFor="let row of data ?? []">
                    <td *ngIf="showCheckboxes" class="table-checkbox-col">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            [checked]="isRowSelected(row)"
                            (change)="onRowCheckboxChange(row, $any($event.target).checked)"
                            [attr.aria-label]="'Seleccionar fila ' + rowSelectionKey(row)" />
                    </td>
                    <td
                        *ngFor="let column of columns"
                        [style.width]="getColumnWidth(column)">
                        <span
                            *ngIf="column.toHtml; else plainCell"
                            [innerHTML]="cellHtml(row, column.campo)"></span>
                        <ng-template #plainCell>{{
                            formatCell(row, column.campo)
                        }}</ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <!-- Paginador inferior (estilo clasificación comercializador) -->
        <div *ngIf="data?.length > 0" class="d-flex justify-content-center mt-4">
            <div class="d-flex align-items-center gap-3">
                <button
                    class="btn btn-outline-success btn-sm"
                    (click)="onPaginaAnterior()"
                    [disabled]="page === 1">
                    ‹ Anterior
                </button>
                <span class="text-secondary small">
                    Página
                    <strong>{{ page }}</strong>
                    de
                    <strong>{{ totalPaginas }}</strong>
                </span>
                <button
                    class="btn btn-outline-success btn-sm"
                    (click)="onPaginaSiguiente()"
                    [disabled]="page === totalPaginas">
                    Siguiente ›
                </button>
            </div>
        </div>

        <div *ngIf="data?.length > 0" class="mt-2 text-muted small text-center">
            Mostrando {{ data.length }} de {{ total }} {{ textoRegistros }}.
        </div>

        <!-- Paginador anterior (Bootstrap pagination)
        <div class="row mt-2" *ngIf="total > 0">
            <div class="col-md-4 d-flex align-items-center">
                <span class="text-muted small">
                    Mostrando {{ rangoDesde }} – {{ rangoHasta }} de {{ total }}
                </span>
            </div>

            <div class="col-md-4 d-flex justify-content-center">
                <nav>
                    <ul class="pagination pagination-sm mb-0">
                        <li class="page-item" [class.disabled]="page === 1">
                            <a class="page-link" (click)="cambiarPagina(1)">«</a>
                        </li>
                        <li class="page-item" [class.disabled]="page === 1">
                            <a class="page-link" (click)="cambiarPagina(page - 1)">‹</a>
                        </li>
                        <li class="page-item" *ngFor="let p of paginas" [class.active]="p === page">
                            <a class="page-link" (click)="cambiarPagina(p)">{{ p }}</a>
                        </li>
                        <li class="page-item" [class.disabled]="page === totalPaginas">
                            <a class="page-link" (click)="cambiarPagina(page + 1)">›</a>
                        </li>
                        <li class="page-item" [class.disabled]="page === totalPaginas">
                            <a class="page-link" (click)="cambiarPagina(totalPaginas)">»</a>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="col-md-4 d-flex justify-content-end align-items-center gap-2">
                <label class="text-muted small mb-0">Filas:</label>
                <select class="form-control form-control-sm w-auto" [(ngModel)]="pageSize"
                    (change)="onPageSizeChange()">
                    <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
                </select>
            </div>
        </div>
        -->
    </div>
</div>